const formatCpf = (val) => {
    if (typeof val === 'string') {
        return val.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
    }
    return val
}

export default formatCpf